import {
    ADD_PATIENT_SUCCESS,
    ADD_PATIENT_FAILURE,
    GET_PATIENT_LIST_REQUEST,
    GET_PATIENT_LIST_SUCCESS,
    GET_PATIENT_LIST_FAILURE,
    ADD_BOOKING_SUCCESS,
    ADD_BOOKING_FAILURE,
    DELETE_PATIENT_SUCCESS,
    DELETE_PATIENT_FAILURE,
    EDIT_PATIENT_SUCCESS,
    EDIT_PATIENT_FAILURE,
    UPDATE_GUIDE_SUCCESS,
    UPDATE_GUIDE_FAILURE,
    GET_CASE_DETAILS_SUCCESS,
    GET_CASE_DETAILS_FAILURE,
    ADD_PICKUP_SUCCESS,
    ADD_PICKUP_FAILURE, ADD_PICKUP_REQUEST, GET_CASE_DETAILS_REQUEST, ADD_BOOKING_REQUEST,
    GET_PARENT_CASES_FAILURE,
    GET_PARENT_CASES,
    GET_PARENT_CASES_SUCCESS,
    SET_FILTER_VALUES_DENTIST,
    ADD_PATIENT_REQUEST, EDIT_PATIENT_REQUEST, DELETE_PATIENT_REQUEST
} from './constants';

const initialState = {
    patientList: [],
    tableConfigDentist: {},
    added: undefined,
    addBookingRequest: undefined,
    unauthorized: false,
    loadingBookings: false,
    loadingPatient:false,
    bookings: {},
    deletePatient: undefined,
    editPatient: undefined,
    editGuide: undefined,
    caseList: undefined,
    addedData: undefined,
    pickupScheduled: undefined,
    gotCaseDetails: false,
    addingDataLoading: false,
    parentCases: [],
    validationMessage: undefined
};

const homeReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PATIENT_REQUEST: {
            return Object.assign({}, state, {loadingBookings: false, added:false, patientAdded: undefined, patientDeleted: undefined, loadingPatient:true, deletePatient: undefined,pickupScheduled: false});
        }
        case ADD_PATIENT_SUCCESS: {
            return Object.assign({}, state, {loadingBookings: false, added:true, addBookingRequest: undefined, deletePatient: undefined, loadingPatient: false, patientList: action.data, editPatient: undefined, editGuide: undefined});
        }
        case ADD_PATIENT_FAILURE: {
            return Object.assign({}, state, {loadingBookings: false, added:false, addBookingRequest: undefined, deletePatient: undefined, loadingPatient: false, patientList: [], editPatient: undefined, editGuide: undefined});
        }
        case GET_PATIENT_LIST_REQUEST: {
            return Object.assign({}, state, {loadingBookings: false, addBookingRequest: undefined, deletePatient: undefined, added: undefined, editPatient: undefined, editGuide: undefined, pickupScheduled: false});
        }
        case GET_PATIENT_LIST_SUCCESS: {
            return Object.assign({}, state, {loadingBookings: false, addBookingRequest: undefined, deletePatient: undefined, added: undefined, patientList: action.data, editPatient: undefined, editGuide: undefined, tableConfigDentist: {...action.data.tableConfig, filter: true}});
        }
        case GET_PATIENT_LIST_FAILURE: {
            return Object.assign({}, state, {loadingBookings: false, addBookingRequest: undefined, deletePatient: undefined, added: undefined, patientList: [], editPatient: undefined, editGuide: undefined});
        }
        case ADD_BOOKING_REQUEST: {
            return Object.assign({}, state, {loadingBookings: false, addingDataLoading: true, addBookingRequest: undefined, unauthorized: false, deletePatient: undefined, added: undefined, editPatient: undefined, editGuide: undefined, pickupScheduled: false});
        }
        case ADD_BOOKING_SUCCESS: {
            return Object.assign({}, state, {loadingBookings: false, addingDataLoading: false, addBookingRequest: true, unauthorized: false, deletePatient: undefined, added: undefined, patientList: action.data, editPatient: undefined, editGuide: undefined, addedData: action.data.bookingId});
        }
        case ADD_BOOKING_FAILURE: {
            return Object.assign({}, state, {loadingBookings: false, addingDataLoading: false, addBookingRequest: false, unauthorized: true, deletePatient: undefined, added: undefined, editPatient: undefined, editGuide: undefined, addedData: undefined});
        }
        case DELETE_PATIENT_SUCCESS: {
            return Object.assign({}, state, {loadingBookings: false, addBookingRequest: undefined, deletePatient: true, patientList: action.data, added: undefined, editPatient: undefined, editGuide: undefined,validationMessage: undefined});
        }
        case DELETE_PATIENT_FAILURE: {
            const message = (action.data.error.type === 'VALIDATION_ERROR') ? action.data.error.validationErrors.error[0] : action.data.message;
            return Object.assign({}, state, {loadingBookings: false, addBookingRequest: undefined, deletePatient: false, added: undefined, editPatient: undefined, editGuide: undefined,validationMessage: message});
        }
        case DELETE_PATIENT_REQUEST: {
            return Object.assign({}, state, {loadingBookings: false, addBookingRequest: undefined, deletePatient: false, added: undefined, editPatient: undefined, editGuide: undefined,validationMessage: undefined});
        }
        case EDIT_PATIENT_REQUEST: {
            return Object.assign({}, state, {loadingBookings: false, addBookingRequest: undefined, deletePatient: undefined, added: undefined, editPatient: undefined, patientList: action.data, editGuide: undefined,pickupScheduled: false});
        }
        case EDIT_PATIENT_SUCCESS: {
            return Object.assign({}, state, {loadingBookings: false, addBookingRequest: undefined, deletePatient: undefined, added: undefined, editPatient: true, patientList: action.data, editGuide: undefined});
        }
        case EDIT_PATIENT_FAILURE: {
            return Object.assign({}, state, {loadingBookings: false, addBookingRequest: undefined, deletePatient: undefined, added: undefined, editPatient: false, editGuide: undefined });
        }
        case UPDATE_GUIDE_SUCCESS: {
            return Object.assign({}, state, {loadingBookings: false, addBookingRequest: undefined, deletePatient: undefined, added: undefined, editGuide: true, editPatient: undefined});
        }
        case UPDATE_GUIDE_FAILURE: {
            return Object.assign({}, state, {loadingBookings: false, addBookingRequest: undefined, deletePatient: undefined, added: undefined, editGuide: false, editPatient: undefined });
        }
        case GET_CASE_DETAILS_SUCCESS: {
            return Object.assign({}, state, {loadingBookings: false, gotCaseDetails: true, addBookingRequest: undefined, caseList: action.data});
        }
        case GET_CASE_DETAILS_FAILURE: {
            return Object.assign({}, state, {loadingBookings: false, gotCaseDetails: false, addBookingRequest: undefined, caseList: undefined});
        }
        case GET_CASE_DETAILS_REQUEST: {
            return Object.assign({}, state, {loadingBookings: false, gotCaseDetails: false, addBookingRequest: undefined, caseList: undefined,pickupScheduled: false});
        }
        case ADD_PICKUP_REQUEST: {
            return Object.assign({}, state, {loadingBookings: false, pickupScheduled: undefined});
        }
        case ADD_PICKUP_SUCCESS: {
            return Object.assign({}, state, {loadingBookings: false, addBookingRequest: undefined, deletePatient: undefined, added: undefined, editGuide: false, editPatient: undefined, pickupScheduled: true });
        }
        case ADD_PICKUP_FAILURE: {
            return Object.assign({}, state, {loadingBookings: false, addBookingRequest: undefined, deletePatient: undefined, added: undefined, editGuide: false, editPatient: undefined, pickupScheduled: false });
        }
        case GET_PARENT_CASES:
            return Object.assign({}, state, {pickupScheduled:false,parentCases: []});
        case GET_PARENT_CASES_SUCCESS: {
            return Object.assign({}, state, {parentCases: action.data});
        }
        case GET_PARENT_CASES_FAILURE: {
            return Object.assign({}, state, {parentCases : []});
        }
        case SET_FILTER_VALUES_DENTIST: {
            return Object.assign({}, state, {tableConfigDentist : {...action.data, filter: true}});
        }
        default: {
            return state;
        }
    }
};

export default homeReducer;



// WEBPACK FOOTER //
// ./src/containers/Layouts/User/Home/reducer.js